import React from 'react'
import { Link } from '../../../utils/links'
import { HomePage } from '../cmsPageState'
import { Image } from '../../../utils/images'
import {
  pageheaderLargeSrc,
  pageheaderSmallSrc,
  pageheaderLargeSrcSet,
  pageheaderSmallSrcSet
} from '../../../utils/imageSizes'
import { getImageUrls } from '../../../utils/sharepointImageUrls'
import { datalayerHandler } from '../../../utils/datalayer'
import { maybeToMailPlusLink } from '../../../utils/mailplus'
import { getCookie } from '../../../utils/cookies'

type HomePageHeaderProps = {} & HomePage

export const HomePageHeader = (props: HomePageHeaderProps) => {
  const { title, intro, image, video, primaryButton, secondaryButton } = props
  const fullsize = true
  const inverted = false

  const imageVisual = image && <div className="pageheader__media">
    <Image
      src={fullsize ? pageheaderLargeSrc : pageheaderSmallSrc}
      srcset={
        fullsize ? pageheaderLargeSrcSet : pageheaderSmallSrcSet
      }
      lazyload={false}
      sizes={fullsize ? "100vw" : "(min-width: 1040px) 1040px, 100vw"}
      urls={getImageUrls(image)}
      classNames={{
        image: 'pageheader__image'
      }}
      width={fullsize ? '1560' : '1040'}
      height={fullsize ? '600' : '434'}
      keepOriginalSize={false}
    />
  </div>

  const videoVisual = (video && video.url && getCookie('video-cookies') === 'yes') && <div className="pageheader__video">
    <iframe tabIndex={-1}
      className="pageheader__iframe"
      title="Evofenedex"
      src={`${video.url}?autoplay=1&mute=1&controls=0&loop=1&disablekb=1&playlist=${video.url.split('embed/')[1]}`}
      allow="autoplay"
      allowFullScreen={false}
      loading='lazy'
      referrerPolicy="strict-origin-when-cross-origin"
      frameBorder="0"/>
  </div>

  return (
    <header className={`pageheader pageheader--${image ? 'image' : 'text'} pageheader--${fullsize ? 'fw' : 'cw'}`}>
      <div className="pageheader__inner">
        <div className="pageheader__content container--s gutter--m spacing--m">
          <h1 className="pageheader__title title--l">{title}</h1>

          {intro && <p className="pageheader__intro">{intro}</p>}

          {(primaryButton?.slug || secondaryButton?.slug) && (
            <div className="pageheader__clickables">
              {primaryButton?.slug && (
                <div className="pageheader__clickable">
                  <Link
                    url={primaryButton.slug}
                    className={`button button--primary${
                      inverted ? '-inverted' : ''
                    }`}
                    onClick={() =>
                      datalayerHandler('header_cta', primaryButton.title, 'header_cta', {
                        link: maybeToMailPlusLink(primaryButton.slug)
                      })}
                  >
                    <span className="button__label">{primaryButton.title}</span>
                  </Link>
                </div>
              )}

              {secondaryButton?.slug && (
                <div className="pageheader__clickable">
                  <Link
                    url={secondaryButton.slug}
                    className={`button button--secondary${
                      inverted ? '-inverted' : ''
                    }`}
                    onClick={() =>
                      datalayerHandler('header_cta', secondaryButton.title, 'header_cta', {
                        link: maybeToMailPlusLink(secondaryButton.slug)
                      })}
                  >
                    <span className="button__label">
                      {secondaryButton.title}
                    </span>
                  </Link>
                </div>
              )}
            </div>
          )}
        </div>

        {(videoVisual || imageVisual) && (
          <div className="pageheader__visual" aria-hidden="true">
            <div className={`${ fullsize ? 'pageheader__figure' : 'container--m gutter--m' }`}>
              {imageVisual && imageVisual}
              {videoVisual && videoVisual}
            </div>
          </div>
        )}
      </div>
    </header>
  )
}
